const SYSTEM_KEYS_ATTR_MAP = {
    projectName: 'projectname',
    requestId: 'requestid',
    versionCommit: 'versioncommit',
};
const SYSTEM_KEYS_QUERY_MAP = {
    projectName: 'projectName',
    requestId: 'requestId',
    versionCommit: 'versionCommit',
};
const SYSTEM_KEYS = {
    projectName: 'projectName',
    requestId: 'requestId',
    versionCommit: 'version.commit',
};

export { SYSTEM_KEYS, SYSTEM_KEYS_ATTR_MAP, SYSTEM_KEYS_QUERY_MAP };
//# sourceMappingURL=constants.mjs.map
